
<div class="sidebar-wrapper">
  <div class="logo">
    <a class="simple-text logo-mini">
      <div class="logo-image-small">
        <img src="assets/images/favicon.png">
      </div>
    </a>
    <a class="simple-text logo-normal">
      Noteefy
    </a>
  </div>
    <ul class="nav" *ngIf="(userService.currentUserReadOnly | async)?.subscriptionFinalized">
        <li *ngFor="let menuItem of menuItemsGlobal" routerLinkActive="active" class="{{menuItem.class}}">
            <ng-container *ngIf="(userService.role!=='admin' && userService.role!=='key-user' && menuItem.allowUser)
                                || (userService.role==='admin' && menuItem.allowAdmin)
                                || (userService.role==='admin' && menuItem.allowKeyUserIfSelectedUser && userService.selectedCustomer)
                                || (userService.role==='key-user' && menuItem.allowKeyUser)
                                || (userService.role==='key-user' && menuItem.allowKeyUserIfSelectedUser && userService.selectedCustomer)">
                <a [routerLink]="[menuItem.path]">
                    <i class="nc-icon {{menuItem.icon}}"></i>
                    <p>{{menuItem.title}}</p>
                </a>
            </ng-container>
        </li>

        <li *ngIf="userService.selectedCustomer" routerLinkActive="none" class="alert-danger" (click)="unselectCustomer()">
            <a>
                <p class="user-connected">Client sélectionné : {{userService.selectedCustomer.email}}</p>
            </a>
        </li>

        <ng-container *ngFor="let item of menuItemsUser">
          <!-- 🔹 PARENT VISUEL -->
          <li *ngIf="item.class === 'menu-parent' && !item.parent && canDisplay(item)"
              class="menu-parent">

            <div class="menu-parent-title">
              <i class="nc-icon {{ item.icon }}"></i>
              <span>{{ item.title }}</span>
            </div>

            <!-- 🔸 ENFANTS -->
            <ul class="submenu">
              <ng-container *ngFor="let child of menuItemsUser | childrenOf:item.title">
                <li *ngIf="canDisplay(child)"
                    routerLinkActive="active">
                  <a [routerLink]="child.path">
                    <i class="nc-icon {{ child.icon }}"></i>
                    <p>{{ child.title }}</p>
                  </a>
                </li>
              </ng-container>
            </ul>
          </li>

          <!-- 🔹 ITEM USER SANS PARENT -->
          <li *ngIf="!item.parent 
                    && item.class !== 'menu-parent' 
                    && canDisplay(item)"
              routerLinkActive="active"
              class="{{ item.class }}">

            <a [routerLink]="item.path">
              <i class="nc-icon {{ item.icon }}"></i>
              <p>{{ item.title }}<span *ngIf="menuCount(item) > 0" class="badge badge-pill badge-warning menu-count" [title]="menuCountTitle(item)">{{ menuCount(item) }}</span></p>
            </a>
          </li>

        </ng-container>

    </ul>
</div>
